import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/materialRequestTemplatesActions'
import * as api from '../../api/template'

function* getMaterialRequestTemplates(action) {
  try {
    const payload = yield call(api.getMaterialRequestTemplatesList)
    yield put({ type: constants.GET_MATERIAL_REQUEST_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_MATERIAL_REQUEST_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetMaterialRequestTemplates() {
  yield takeLatest(constants.GET_MATERIAL_REQUEST_TEMPLATES.ACTION, getMaterialRequestTemplates)
}

function* getMaterialRequestTemplateItems(action) {
  try {
    const payload = yield call(api.getMaterialRequestTemplatesItems, action.materialRequestId)
    yield put({ type: constants.GET_MATERIAL_REQUEST_TEMPLATE_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_MATERIAL_REQUEST_TEMPLATE_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTemplateItems() {
  yield takeLatest(
    constants.GET_MATERIAL_REQUEST_TEMPLATE_ITEMS.ACTION,
    getMaterialRequestTemplateItems
  )
}

export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchGetMaterialRequestTemplates), fork(watchGetTemplateItems)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/materialRequestTemplateSaga.js